import { render, staticRenderFns } from "./AccountAvatarManager.vue?vue&type=template&id=4acc2e4c&scoped=true&"
import script from "./AccountAvatarManager.vue?vue&type=script&lang=js&"
export * from "./AccountAvatarManager.vue?vue&type=script&lang=js&"
import style0 from "./AccountAvatarManager.vue?vue&type=style&index=0&id=4acc2e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc2e4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VIcon,VRow})
